// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1MA1f","bigColWidth":"Table_bigColWidth__3G_DG","biggerColWidth":"Table_biggerColWidth__3v0-d","row":"Table_row__2BqLX","col":"Table_col__1QqBE"};